import { useEffect, useState } from "react";

import { UserPrivateRequestNickname } from "@features/privateRequest/PrivateRequestBar/UserPrivateRequestNickname";

import { Button } from "@components/Button";
import { Image } from "@components/Image";
import { Separator } from "@components/Separator";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { EBroadcastStatus } from "@api/broadcast";
import { TGetPrivateRequestResponse } from "@api/privateRequests";

import { useBroadcastStatusDataQuery } from "@storage/queries/broadcast/useBroadcastStatusDataQuery";

import { Call } from "@lib/call";

import { ICON_PATHS } from "@configs/icons";

import { PrivateRequestActions } from "./PrivateRequestActions";
import { PrivateRequestTimer } from "./PrivateRequestTimer";

let webRtcCall: Call | null = null;

export const PrivateRequestBar = () => {
	const [showPreAudioBlock, setShowPreAudioBlock] = useState(true);
	const { broadcastStatus, privateInfo } = useBroadcastStatusDataQuery();

	useEffect(
		() => () => {
			webRtcCall && webRtcCall.stop();
		},
		[],
	);

	useEffect(() => {
		if (broadcastStatus === EBroadcastStatus.PUBLIC) {
			setShowPreAudioBlock(true);
		}
	}, [broadcastStatus]);

	const handleStartAudioPrivate = async () => {
		const id = privateInfo?.privateRoomChatId;
		webRtcCall = new Call().enableDebug();
		await webRtcCall.configure();
		await webRtcCall.start(id);
		setShowPreAudioBlock(false);
	};

	const mute = (data: boolean) => {
		webRtcCall && webRtcCall.mute(data);
	};

	const changeVolume = (data: number) => {
		webRtcCall && webRtcCall.changeVolume(data);
	};

	if (privateInfo === null || privateInfo.outerPrivate) {
		return null;
	}

	return (
		<div className="absolute z-sticky w-full">
			<div className="mx-2.5 mt-2.5 rounded-xl bg-block px-3 py-2">
				{showPreAudioBlock && privateInfo?.isWithClientAudio ? (
					<>
						<div className="flex items-center justify-between">
							<Stack direction="row" spacing={8} align="center">
								<Image src={ICON_PATHS.PRIVATE_AUDIO_REQUEST} alt="icon" />
								<Typography size="sm" weight="bold" padding="none">
									Voice private show
								</Typography>
							</Stack>
						</div>
						<Stack direction="row" spacing={8} align="center" justify="between">
							<Typography padding="none">Please confirm connection to audio chat</Typography>
							<Button type="primary" onClick={handleStartAudioPrivate}>
								<Typography size="sm" padding="none" weight="bold">
									Confirm
								</Typography>
							</Button>
						</Stack>
					</>
				) : (
					<>
						<div className="flex items-center justify-between">
							<Stack direction="row" justify="between" align="center">
								{privateInfo?.isWithClientAudio ? (
									<Stack direction="row" spacing={8} align="center">
										<Image src={ICON_PATHS.PRIVATE_AUDIO_REQUEST} alt="icon" />

										<Typography size="sm" weight="bold" padding="none">
											Voice private show
										</Typography>
									</Stack>
								) : (
									<Stack direction="row" spacing={8} align="center">
										<Image src={ICON_PATHS.PRIVATE_CHAT_REQUEST} alt="icon" />
										<Typography size="sm" weight="bold" padding="none">
											Private show
										</Typography>
									</Stack>
								)}
							</Stack>
							<PrivateRequestTimer />
						</div>
						<Separator orientation="horizontal" className="my-2" />
						<Stack direction="row" justify="between" align="center">
							<Stack>
								<UserPrivateRequestNickname user={privateInfo as unknown as TGetPrivateRequestResponse} />
								<Typography size="sm" padding="none">
									{privateInfo?.balance?.toLocaleString("ru")} tk
								</Typography>
							</Stack>
							<PrivateRequestActions
								id={privateInfo?.privateRequestId}
								isWithClientAudio={privateInfo?.isWithClientAudio}
								mute={mute}
								changeVolume={changeVolume}
							/>
						</Stack>
					</>
				)}
			</div>
		</div>
	);
};
